<span class="text-3xl">{{ 'familyTree.title' | translate }}</span>

<p>{{ 'familyTree.description' | translate }}</p>
<button
  kendoButton
  themeColor="primary"
  class="uppercase"
  maximizerShowcaseBookDemo
>
  {{ 'familyTree.button.action' | translate }}
</button>
